const fileInput = document.getElementById('PhotoID') as HTMLInputElement;
const fileSizeDisplay = document.getElementById('fileSizeError') as HTMLDivElement;
const photoIDInput = document.getElementById('PhotoID') as HTMLInputElement;
const photoidSrcImage = document.getElementById('photoid-src') as HTMLImageElement;

if(fileInput)
{
  fileInput.addEventListener('change', (event) => {
    const selectedFile = (event.target as HTMLInputElement).files?.[0];
    if (selectedFile) {
      const fileSizeInBytes = selectedFile.size;
      const fileSizeInKb = fileSizeInBytes / 1024;
      const fileSizeInMb = fileSizeInKb / 1024;
      const fileSizeInGb = fileSizeInMb / 1024;
      if (fileSizeInGb > 1) {
        fileSizeDisplay.textContent = 'File size exceeds 1GB limit.';
        fileInput.value = '';
      } else {
        fileSizeDisplay.textContent = '';
      }
    }
  });
}

if(photoIDInput)
{
  photoIDInput.onchange = function (this: HTMLInputElement) {
    const src = URL.createObjectURL(this.files![0]);
    photoidSrcImage.src = src;
  };
}
